module.exports = __webpack_public_path__ + "open-iconic.eca2c26759a009a4a936.svg";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/assets/open-iconic-master/font/fonts/open-iconic.svg
// module id = ../../../../../src/assets/open-iconic-master/font/fonts/open-iconic.svg
// module chunks = styles